<template>
    <div class="container-fluid pb-5">
        <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 px-3 px-md-0">
            <div>
                <h3 class="fw-bold mb-1">Umowy komisowe</h3>
                <p class="text-muted small mb-0">Lista umów komisowych wystawionych na koncie</p>
            </div>
            <button
                class="btn btn-primary-dark d-flex align-items-center justify-content-center gap-2 w-100 btn-responsive-auto"
                @click="openModalForCreate()">
                <i class="bi bi-plus-lg"></i>
                <span>Nowa umowa komisowa</span>
            </button>
        </div>

        <!-- LISTA UMÓW KOMISOWYCH -->
        <div class="card border shadow-sm">
            <div class="card-body">
                <div class="table-responsive">
                    <Vue3EasyDataTable :headers="headers" :items="contracts" :loading="loading" buttons-pagination
                        show-index>
                        <template #item-companyName="item">
                            <span>
                                {{ item.companyName || `${item.firstName || ''} ${item.lastName || ''}`.trim() || '—' }}
                            </span>
                        </template>
                        <template #item-actions="item">
                            <div class="d-flex justify-content-end gap-1 py-1">
                                <button class="btn btn-sm btn-outline-primary" title="Edytuj umowę"
                                    @click="editContract(item)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-secondary" title="Pobierz Umowę PDF"
                                    @click="downloadPDF(item)">
                                    <i class="bi bi-file-earmark-pdf"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-danger" title="Usuń"
                                    @click="deleteContract(item.ID || item.id)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </template>
                    </Vue3EasyDataTable>
                </div>
            </div>
        </div>

        <!-- MODAL TWORZENIA / EDYCJI -->
        <div ref="contractModalRef" class="modal fade" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold">Nowa umowa komisowa</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <form @submit.prevent="saveContract" class="d-flex flex-column" style="max-height: 85vh;">
                        <div class="modal-body custom-scroll-body p-4">
                            <!-- 1. DANE DOKUMENTU -->
                            <DepositSection1 v-model="form" title="Dane dokumentu" :lastDocuments="lastContracts" />
 
                            <!-- 2. DANE POJAZDU (Rozwijana sekcja) -->
                            <CommisionSection2 v-model="form" title="Dane pojazdu" :dicts="dicts"
                                @makeChange="handleFormMakeChange" @saveCarToOffers="saveCarToOffers" />

                            <!-- 3. Z POJAZDEM PRZYJĘTO -->
                            <SaleSectionVehicleState v-model="form" title="Z pojazdem przyjęto" />

                            <!-- 4. KOMIS -->
                            <InvoiceSection4 v-model="form.seller" :dicts="dicts" title="Komis" :hide-personal-fields="true" />

                            <!-- 5. KOMITENT -->
                            <InvoiceSection5 v-model="form.buyer" :dicts="dicts" @fetchGus="fetchGusData"
                                title="Komitent" />

                            <!-- 6. WSPÓŁWŁAŚCICIEL -->
                            <InvoiceSection6 v-model="form.coOwner" :dicts="dicts" title="Współwłaściciel" />

                            <!-- 7. CENA (Rozwijana sekcja) -->

                            <CommisionSection7 v-model="form" :dicts="dicts" title="Cena" />

                            <!-- 8. UMOWA (POSTANOWIENIA PUNKTOWE - również z nagłówkiem zwijanym w komponencie) -->
                            <CommissionSectionProvisions v-model="form.provisions" />

                            <!-- 9. UWAGI -->
                            <DepositSectionNotes v-model="form.notes" />

                            <!-- 10. ZDJĘCIA POJAZDU (Spójne z CarList.vue) -->
                            <div class="row g-3 mb-2">
                                <div
                                    class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2">
                                    <h6 class="fw-bold mb-0">7. Galeria zdjęć</h6>
                                    <span class="badge bg-light text-dark border">
                                        {{ photosList.length }} / {{ maxPhotosAllowed }} zdjęć
                                    </span>
                                </div>
                                <div class="col-12" v-if="photosList.length > 0">
                                    <div class="row g-2 mt-2">
                                        <div v-for="(photo, index) in photosList" :key="index"
                                            class="col-6 col-sm-4 col-md-3">
                                            <div class="card h-100 position-relative border"
                                                :class="{ 'border-primary border-2': photo.main }">
                                                <img :src="photo.preview" class="card-img-top object-fit-cover"
                                                    style="height: 120px;" />
                                                <div class="card-body p-2 text-center">
                                                    <div class="d-flex justify-content-center gap-1 mb-2">
                                                        <button type="button" class="btn btn-xs btn-outline-secondary"
                                                            :disabled="index === 0" @click="movePhoto(index, -1)">
                                                            <i class="bi bi-arrow-left"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-xs btn-outline-secondary"
                                                            :disabled="index === photosList.length - 1"
                                                            @click="movePhoto(index, 1)">
                                                            <i class="bi bi-arrow-right"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-xs btn-outline-danger"
                                                            @click="removePhoto(index)">
                                                            <i class="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                    <button type="button" class="btn btn-sm w-100"
                                                        :class="photo.main ? 'btn-primary' : 'btn-outline-primary'"
                                                        @click="setMainPhoto(index)">
                                                        {{ photo.main ? 'Główne' : 'Ustaw główne' }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="drop-zone border-2 border-dashed rounded p-4 text-center cursor-pointer"
                                        :class="{
                                            'drop-zone-active bg-light-primary border-primary': isDragging && photosList.length < maxPhotosAllowed,
                                            'bg-light text-muted opacity-75 cursor-not-allowed': photosList.length >= maxPhotosAllowed
                                        }" @dragover.prevent="isDragging = photosList.length < maxPhotosAllowed"
                                        @dragleave.prevent="isDragging = false" @drop.prevent="handleDrop"
                                        @click="triggerFileInput">

                                        <i class="bi fs-2"
                                            :class="photosList.length >= maxPhotosAllowed ? 'bi-image text-secondary' : 'bi-cloud-arrow-up text-primary'"></i>

                                        <p class="mb-0 mt-2 fw-medium" v-if="photosList.length < maxPhotosAllowed">
                                            Przeciągnij i upuść zdjęcia tutaj lub <span
                                                class="text-primary text-decoration-underline">wybierz z pliku</span>
                                        </p>
                                        <p class="mb-0 mt-2 fw-medium text-warning" v-else>
                                            Osiągnięto limit {{ maxPhotosAllowed }} zdjęć dla wybranego pakietu
                                        </p>

                                        <span class="text-muted extra-small">Obsługiwane formaty: JPG, PNG, WEBP</span>
                                        <input type="file" ref="fileInput" class="d-none" multiple accept="image/*"
                                            :disabled="photosList.length >= maxPhotosAllowed"
                                            @change="handlePhotosSelect" />
                                    </div>
                                </div>
                            </div>

                            <div v-if="missingWarnings.length > 0" class="alert alert-warning mb-3">
                                <div class="fw-bold mb-1">W dokumencie brakuje istotnych danych (nie są obowiązkowe):
                                </div>
                                <ul class="mb-0 ps-3">
                                    <li v-for="warn in missingWarnings" :key="warn" class="fst-italic">{{ warn }}</li>
                                </ul>
                            </div>
                        </div>

                        <div class="modal-footer bg-light d-flex justify-content-between flex-wrap gap-2">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Anuluj</button>
                            <div class="d-flex gap-2">
                                <button type="submit" class="btn btn-success" :disabled="saving">
                                    <i class="bi bi-save me-1"></i>Zapisz
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <AppLoader :show="saving || loading" :text="loaderText" />

        <div style="position: absolute; left: -9999px; top: -9999px;">
            <CommissionContractTemplate ref="contractPdfRenderArea" v-if="pdfContractDetails"
                :contract="pdfContractDetails" />
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, nextTick } from 'vue'
import apiClient from '@/api'
import html2pdf from 'html2pdf.js'
import Modal from 'bootstrap/js/dist/modal'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import AppLoader from '@/components/AppLoader.vue'
import { webAlert, showConfirm } from '@/utils/dialog'

import InvoiceSection4 from '@/components/invoices/InvoiceSection4.vue'
import InvoiceSection5 from '@/components/invoices/InvoiceSection5.vue'
import InvoiceSection6 from '@/components/invoices/InvoiceSection6.vue'
import CommisionSection2 from '../components/commission/CommisionSection2.vue'
import CommisionSection7 from '../components/commission/CommisionSection7.vue'
import { validateVIN, validatePESEL } from '@/utils/validators'

import DepositSection1 from '@/components/deposit/DepositSection1.vue'
import DepositSectionNotes from '@/components/deposit/DepositSectionNotes.vue'
import SaleSectionVehicleState from '@/components/sale/SaleSectionVehicleState.vue'
import CommissionSectionProvisions, { defaultCommissionPoints } from '@/components/commission/CommissionSectionProvisions.vue'
import CommissionContractTemplate from '@/components/templates/CommissionContractTemplate.vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const loading = ref(false)
const saving = ref(false)
const loaderText = ref('')
const contracts = ref([])
const lastContracts = ref([])
const contractModalRef = ref(null)
let contractModalInstance = null

const pdfContractDetails = ref(null)
const contractPdfRenderArea = ref(null)
const fileInput = ref(null)
const photosList = ref([])
const maxPhotosAllowed = ref(5)

const headers = [
    { text: 'Numer umowy', value: 'docNumber', sortable: true },
    { text: 'Komitent', value: 'companyName', sortable: true },
    { text: 'Cena pojazdu', value: 'carPrice', sortable: true },
    { text: 'Data wystawienia', value: 'issueDate', sortable: true },
    { text: 'Akcje', value: 'actions', width: 180 }
]

const dicts = reactive({
    currencies: [],
    countries: [],
    paymentTypes: [],
    makes: [],
    models: [],
    gearboxes: [],
    fuelTypes: [],
    colours: [],
    bodyTypes: []
})

const fetchDict = async (action, extraData = {}) => {
    try {
        const res = await apiClient.post({ action, ...extraData })
        return Array.isArray(res.data?.data) ? res.data.data : []
    } catch { return [] }
}

const loadDictionaries = async () => {
    dicts.currencies = await fetchDict('get-currencies')
    dicts.countries = await fetchDict('get-countries')
    dicts.paymentTypes = await fetchDict('get-payment-types')
    dicts.makes = await fetchDict('get-makes')
    dicts.gearboxes = await fetchDict('get-gearboxes')
    dicts.fuelTypes = await fetchDict('get-fueltypes')
    dicts.colours = await fetchDict('get-colours')
    dicts.bodyTypes = await fetchDict('get-bodytypes')
}

const fetchLastContracts = async () => {
    try {
        const response = await apiClient.post({ action: 'get-last-commission-contracts' })
        const rawData = response.data?.data || response.data || []
        lastContracts.value = rawData.map(item => ({
            docNumber: item.docNumber,
            createDate: item.issueDate || item.createDate
        }))
    } catch {
        lastContracts.value = []
    }
}

const handleFormMakeChange = async (makeId) => {
    // makeId lub form.vehicle.makeID zawiera teraz wybrane ID
    form.vehicle.modelID = null

    const selectedId = makeId || form.vehicle.makeID

    if (selectedId) {
        dicts.models = await fetchDict('get-models', { makeID: selectedId })
        const selectedMake = dicts.makes.find(m => String(m.ID || m.id) === String(selectedId))
        form.vehicle.make = selectedMake ? (selectedMake.name || selectedMake.make) : ''
    } else {
        dicts.models = []
        form.vehicle.make = ''
    }
}
const createEmptyParty = () => ({
    nip: '', companyName: '', firstName: '', lastName: '', country: 'Polska',
    postalCode: '', city: '', street: '', email: '', phone: '', pesel: '',
    idCardSeriesNumber: '', notes: '', bankName: '', bankAccount: ''
})

const createEmptyForm = () => ({
    ID: null,
    carID: null,
    docNumber: '',
    issueDate: new Date().toISOString().substring(0, 10),
    issuePlace: '',
    vehicle: {
        id: null, make: '', model: '', engineCapacity: '', mileage: '', gearbox: '',
        fuelType: '', powerHp: '', color: '', vin: '', type: '', makeID: '', modelID: '',
        registrationPlate: '', productionYear: '', firstRegistrationDate: '', additionalInfo: ''
    },
    ocState: '',
    keysState: '',
    regBookState: '',
    regStickerState: '',
    platesState: '',
    carCardState: '',
    exciseTaxState: '',
    serviceBookState: '',
    seller: createEmptyParty(),
    buyer: createEmptyParty(),
    coOwner: createEmptyParty(),
    carPrice: 0,
    carCurrency: 'PLN',
    commissionAmount: 0,
    commissionCurrency: 'PLN',
    provisions: [...defaultCommissionPoints],
    notes: ''
})

const form = reactive(createEmptyForm())

const missingWarnings = computed(() => {
    const warnings = []
    if (!form.vehicle.make) warnings.push('Brak wybranej marki pojazdu')
    //if (!form.carPrice || Number(form.carPrice) <= 0) warnings.push('brak ceny pojazdu')
    if (!form.docNumber) warnings.push('Brak numer umowy')
    if (!form.issueDate) warnings.push('Brak daty zawarcia umowy')
    if (!form.issuePlace) warnings.push('Brak miejsca zawarcia umowy')
    if (!form.buyer.pesel || !validatePESEL(form.buyer.pesel).valid) warnings.push('Wpisz poprawnie numer PESEL nabywcy')
    if (!form.buyer.idCardSeriesNumber) warnings.push('Wpisz numer dowodu osobistego nabywcy')
    if (!form.commissionAmount || Number(form.commissionAmount) <= 0) warnings.push('brak prowizji komisanta')
    return warnings
})

const loadContracts = async () => {
    loading.value = true
    loaderText.value = 'Pobieranie umów komisowych...'
    try {
        const response = await apiClient.post({ action: 'get-commission-contracts' })
        contracts.value = response.data?.data || []
    } catch {
        webAlert('Błąd podczas pobierania umów komisowych.')
    } finally {
        loading.value = false
    }
}


// Przy wyborze pojazdu z modala lub edycji:
const onVehicleSelected = async (vehicleData) => {
    form.carID = vehicleData.ID || vehicleData.id
    form.vehicle.makeID = vehicleData.makeID || null
    if (form.vehicle.makeID) {
        dicts.models = await fetchDict('get-models', { makeID: form.vehicle.makeID })
    }
    form.vehicle.modelID = vehicleData.modelID || null
    form.vehicle.gearboxID = vehicleData.gearboxID || null
    form.vehicle.fuelTypeID = vehicleData.fuelTypeID || null
    form.vehicle.colourID = vehicleData.colourID || null

    Object.assign(form.vehicle, {
        id: vehicleData.ID || vehicleData.id,
        make: vehicleData.make || '',
        model: vehicleData.model || '',
        engineCapacity: vehicleData.engineCCM || vehicleData.engineCapacity || '',
        mileage: vehicleData.mileage || '',
        type: vehicleData.type || '',
        powerHp: vehicleData.powerKM || vehicleData.powerHp || '',
        vin: vehicleData.VIN || vehicleData.vin || '',
        registrationPlate: vehicleData.registerNumber || vehicleData.registrationPlate || '',
        productionYear: vehicleData.productionYear || '',
        firstRegistrationDate: vehicleData.firstRegistrationDate || '',
        additionalInfo: vehicleData.additionalInfo || vehicleData.offerDesc || ''
    })
    if (vehicleData.price) form.carPrice = Number(vehicleData.price)
}

const fetchGusData = async (type) => {
    const target = form[type]
    if (!target.nip) return
    saving.value = true
    loaderText.value = 'Pobieranie z GUS...'
    try {
        const res = await apiClient.post({ action: 'get_data_from_gus', nip: target.nip })
        if (res.data?.success) {
            Object.assign(target, res.data.company)
            if (type === 'seller') form.issuePlace = target.city
        }
    } finally {
        saving.value = false
    }
}

const triggerFileInput = () => fileInput.value?.click()

const handlePhotosSelect = (e) => {
    if (e.target.files) {
        Array.from(e.target.files).forEach(file => {
            if (file.type.startsWith('image/')) {
                photosList.value.push({
                    file: file,
                    preview: URL.createObjectURL(file),
                    isExisting: false,
                    main: photosList.value.length === 0
                })
            }
        })
        e.target.value = ''
    }
}

const handleDrop = (e) => {
    if (e.dataTransfer?.files) {
        Array.from(e.dataTransfer.files).forEach(file => {
            if (file.type.startsWith('image/')) {
                photosList.value.push({
                    file: file,
                    preview: URL.createObjectURL(file),
                    isExisting: false,
                    main: photosList.value.length === 0
                })
            }
        })
    }
}

const removePhoto = (index) => {
    const wasMain = photosList.value[index].main
    photosList.value.splice(index, 1)
    if (wasMain && photosList.value.length > 0) photosList.value[0].main = true
}

const setMainPhoto = (index) => {
    photosList.value.forEach((p, i) => { p.main = (i === index) })
}

const movePhoto = (index, direction) => {
    const newIndex = index + direction
    if (newIndex < 0 || newIndex >= photosList.value.length) return
    const temp = photosList.value[index]
    photosList.value[index] = photosList.value[newIndex]
    photosList.value[newIndex] = temp
}

const openModalForCreate = () => {
    Object.assign(form, createEmptyForm())
    photosList.value = []
    fetchLastContracts()
    contractModalInstance.show()
}

const editContract = async (item) => {
    saving.value = true
    loaderText.value = 'Pobieranie danych umowy...'
    try {
        const response = await apiClient.post({ action: 'get-commission-contract', ID: item.ID || item.id })
        const data = response.data?.data?.[0] || response.data?.data || response.data
        if (data) {
            if (typeof data.provisions === 'string') {
                data.provisions = data.provisions.split('\n').filter(Boolean)
            }
            Object.assign(form, createEmptyForm(), data)
            if (data.car) onVehicleSelected(data.car)
            if (Array.isArray(data.photos)) {
                photosList.value = data.photos.map(p => ({
                    file: null,
                    preview: p.preview,
                    isExisting: true,
                    photoID: p.photoID,
                    main: p.main === 'yes'
                }))
            }
        }
        contractModalInstance.show()
    } catch {
        webAlert('Nie udało się pobrać danych umowy.')
    } finally {
        saving.value = false
    }
}

const saveContract = async () => {
    if (form.vehicle && form.vehicle.vin && form.vehicle.vin.trim() !== '') {
        const vinCheck = validateVIN(form.vehicle.vin)
        if (!vinCheck.valid) {
            webAlert(vinCheck.message)
            return // Blokuje zapis umowy
        }
    }

    if (form.buyer && form.buyer.pesel && form.buyer.pesel.trim() !== '') {
        const peselCheck = validatePESEL(form.buyer.pesel)
        if (!peselCheck.valid) {
            webAlert(`Komitent: ${peselCheck.message}`)
            return
        }
    }

    if (form.coOwner && form.coOwner.pesel && form.coOwner.pesel.trim() !== '') {
        const peselCheck = validatePESEL(form.coOwner.pesel)
        if (!peselCheck.valid) {
            webAlert(`Komitent: ${peselCheck.message}`)
            return
        }
    }

    saving.value = true
    loaderText.value = 'Zapisywanie umowy komisowej...'

    try {
        const payload = new FormData()
        payload.append('action', 'save-commission-contract')

        // 1. Główne dane umowy (zagnieżdżone w contract[...])
        payload.append('contract[ID]', form.id || form.ID || '')
        payload.append('contract[carID]', form.carID || '')
        payload.append('contract[docNumber]', form.docNumber || '')
        payload.append('contract[correctedInvoiceNumber]', form.correctedInvoiceNumber || '')
        payload.append('contract[issueDate]', form.issueDate || '')
        payload.append('contract[issuePlace]', form.issuePlace || '')

        // 2. Stan pojazdu i dane dodatkowe
        payload.append('contract[ocState]', form.ocState || '')
        payload.append('contract[keysState]', form.keysState || '')
        payload.append('contract[regBookState]', form.regBookState || '')
        payload.append('contract[regStickerState]', form.regStickerState || '')
        payload.append('contract[platesState]', form.platesState || '')
        payload.append('contract[carCardState]', form.carCardState || '')
        payload.append('contract[exciseTaxState]', form.exciseTaxState || '')
        payload.append('contract[serviceBookState]', form.serviceBookState || '')
        payload.append('contract[additionalEquipment]', form.additionalEquipment || '')
        payload.append('contract[vehicleStateNotes]', form.vehicleStateNotes || '')

        // 3. Cena i prowizja
        payload.append('contract[carPrice]', form.carPrice || 0)
        payload.append('contract[carCurrency]', form.carCurrency || 'PLN')
        payload.append('contract[commissionAmount]', form.commissionAmount || 0)
        payload.append('contract[commissionCurrency]', form.commissionCurrency || 'PLN')

        // 4. Dane pojazdu (zagnieżdżone w contract[vehicle][...])
        if (form.vehicle) {
            payload.append('contract[vehicle][id]', form.vehicle.id || '')
            payload.append('contract[vehicle][make]', form.vehicle.make || '')
            payload.append('contract[vehicle][model]', form.vehicle.model || '')
            payload.append('contract[vehicle][makeID]', form.vehicle.makeID || '')
            payload.append('contract[vehicle][modelID]', form.vehicle.modelID || '')
            payload.append('contract[vehicle][type]', form.vehicle.type || '')
            payload.append('contract[vehicle][productionYear]', form.vehicle.productionYear || '')
            payload.append('contract[vehicle][firstRegistrationDate]', form.vehicle.firstRegistrationDate || '')
            payload.append('contract[vehicle][vin]', form.vehicle.vin || '')
            payload.append('contract[vehicle][registrationPlate]', form.vehicle.registrationPlate || '')
            payload.append('contract[vehicle][engineCapacity]', form.vehicle.engineCapacity || '')
            payload.append('contract[vehicle][powerHp]', form.vehicle.powerHp || '')
            payload.append('contract[vehicle][gearbox]', form.vehicle.gearbox || '')
            payload.append('contract[vehicle][gearboxID]', form.vehicle.gearboxID || '')
            payload.append('contract[vehicle][fuelType]', form.vehicle.fuelType || '')
            payload.append('contract[vehicle][fuelTypeID]', form.vehicle.fuelTypeID || '')
            payload.append('contract[vehicle][color]', form.vehicle.color || '')
            payload.append('contract[vehicle][colourID]', form.vehicle.colourID || '')
            payload.append('contract[vehicle][additionalInfo]', form.vehicle.additionalInfo || '')
            payload.append('contract[vehicle][mileage]', form.vehicle.mileage || '')

        }

        // 5. Strony umowy (zagnieżdżone w contract[seller][...], contract[buyer][...], contract[coOwner][...])
        ['seller', 'buyer', 'coOwner'].forEach((role) => {
            const party = form[role]
            if (party) {
                payload.append(`contract[${role}][nip]`, party.nip || '')
                payload.append(`contract[${role}][companyName]`, party.companyName || '')
                payload.append(`contract[${role}][firstName]`, party.firstName || '')
                payload.append(`contract[${role}][lastName]`, party.lastName || '')
                payload.append(`contract[${role}][country]`, party.country || '')
                payload.append(`contract[${role}][postalCode]`, party.postalCode || '')
                payload.append(`contract[${role}][city]`, party.city || '')
                payload.append(`contract[${role}][street]`, party.street || '')
                payload.append(`contract[${role}][email]`, party.email || '')
                payload.append(`contract[${role}][phone]`, party.phone || '')
                payload.append(`contract[${role}][pesel]`, party.pesel || '')
                payload.append(`contract[${role}][idCardSeriesNumber]`, party.idCardSeriesNumber || '')
                payload.append(`contract[${role}][notes]`, party.notes || '')
                payload.append(`contract[${role}][bankName]`, party.bankName || '')
                payload.append(`contract[${role}][bankAccount]`, party.bankAccount || '')
            }
        })

        // 6. Postanowienia i uwagi
        if (Array.isArray(form.provisions)) {
            form.provisions.forEach((provision) => {
                payload.append('contract[provisions][]', provision || '')
            })
        }
        payload.append('contract[notes]', form.notes || '')

        // 7. Metadane zdjęć oraz pliki (poza głównym obiektem contract, tak jak miałeś)
        const photosMeta = photosList.value.map((p, idx) => ({
            position: idx + 1,
            main: p.main ? 'yes' : 'no',
            isExisting: p.isExisting,
            photoID: p.photoID
        }))
        payload.append('photosMeta', JSON.stringify(photosMeta))

        photosList.value.forEach((p) => {
            if (!p.isExisting && p.file) {
                payload.append('photos[]', p.file)
            }
        })

        const response = await apiClient.post(payload)
        const resData = response.data || response

        saving.value = false

        if (resData?.status === 'success' || resData?.success || resData?.ID || resData?.id) {
            contractModalInstance.hide()
            await loadContracts()
            await webAlert({ message: resData?.message || 'Umowa komisowa została zapisana.', status: 'success'} )
        } else {
            await webAlert(resData)
        }
    } catch (error) {
        console.error('Błąd zapisu umowy:', error)
        webAlert('Wystąpił błąd podczas połączenia z serwerem.')
    } finally {
        saving.value = false
    }
}

const downloadPDF = async (item) => {
    saving.value = true
    loaderText.value = 'Generowanie PDF...'
    try {
        const response = await apiClient.post({ action: 'get-commission-contract', ID: item.ID || item.id })
        const data = response.data?.data?.[0] || response.data?.data || response.data
        if (!data) {
            webAlert('Nie odnaleziono danych umowy.')
            return
        }

        pdfContractDetails.value = data
        await nextTick()

        const opt = {
            margin: 5,
            filename: `Umowa_Komisowa_${data.docNumber || item.ID}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        }

        const element = contractPdfRenderArea.value?.$el || contractPdfRenderArea.value?.element
        const pdfWorker = html2pdf().set(opt).from(element)
        const pdfBlob = await pdfWorker.output('blob')

        const blobUrl = URL.createObjectURL(pdfBlob)
        window.open(blobUrl, '_blank')
    } catch (error) {
        console.error(error)
        webAlert('Błąd podczas generowania pliku PDF.')
    } finally {
        saving.value = false
    }
}

const deleteContract = async (id) => {
    const confirmed = await showConfirm('Czy na pewno chcesz usunąć tę umowę komisową?', {
        title: 'Usuwanie pozycji',
        confirmText: 'Usuń',
        cancelText: 'Anuluj',
        confirmClass: 'btn-danger',
        icon: 'bi-trash text-danger'
    })
    if (!confirmed) return

    saving.value = true
    loaderText.value = "Kasowanie..."
    try {
        await apiClient.post({ action: 'delete-commission-contract', ID: id })
        await loadContracts()
        webAlert('Usunięto pomyślnie.')
    } catch {
        webAlert('Błąd podczas usuwania pozycji.')
    } finally {
        saving.value = false
    }
}

const saveCarToOffers = (item) => {
    const contractID = item?.ID || form.ID
    if (!contractID) {
        webAlert('Najpierw zapisz umowę, aby móc dodać pojazd do ofert.')
        return
    }
    router.push({
        path: '/admin/cars',
        query: { importCommissionID: contractID }
    })
}

onMounted(async () => {
    await loadDictionaries()
    contractModalInstance = new Modal(contractModalRef.value)
    await loadContracts()
})
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}

.custom-scroll-body {
    overflow-y: auto;
    max-height: calc(85vh - 130px);
}

.btn-xs {
    padding: 0.15rem 0.4rem;
    font-size: 0.75rem;
}

.drop-zone {
    border: 2px dashed var(--drop-zone-border);
    background-color: var(--drop-zone-bg);
    color: var(--drop-zone-text);
    transition: all 0.2s ease;
}

.drop-zone:hover,
.drop-zone-active {
    border-color: var(--drop-zone-hover-border);
    background-color: var(--drop-zone-hover-bg);
}

.extra-small {
    font-size: 0.75rem;
}
</style>